module.exports = __webpack_public_path__ + "static/media/EUR.047ea49f.svg";